import { GET_CUSTOMER } from './mutation-types';

export default {
  [GET_CUSTOMER](state, data) {
    state.customers = data.customers;
    state.count = data.count;
    state.lastFilter = data.lastFilter;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/customer/mutations.js